const getApiBaseUrl = () => {
  const configuredUrl = process.env.REACT_APP_BACKEND_URL;

  // Always use configured URL if explicitly provided via env vars
  if (configuredUrl) {
    const trimmed = configuredUrl.trim();
    return trimmed.endsWith("/api")
      ? trimmed
      : `${trimmed.replace(/\/$/, "")}/api`;
  }

  // Fallback for deployments using relative paths when no URL is set
  if (typeof window !== "undefined") {
    const host = window.location.hostname.toLowerCase();
    const isOptivraDomain = /(^|\.)optivratech\.com$/.test(host);

    if (isOptivraDomain) {
      return "/api";
    }
  }

  // Default fallback
  return "http://localhost:8000/api";
};

export default getApiBaseUrl;
